import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../../shared/services/shared.service';
import { HelperMethods } from '../../common/helper-methods.service';
import { DtoSchool, DtoSchoolUser } from '../../../models/school.model';
import { AddSchoolUserComponent } from '../../school/add-school-user/add-school-user.component';
import { MatDialogCloseEvent } from '../../../const';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { Role, RolePayload } from '../../../models/role.model';
import { SchoolService } from '../../school/school.service';
import * as XLSX from 'xlsx';
import { RoleMaster } from '../user-role/user-role.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { EditUserRoleComponent } from '../user-role/edit-user-role/edit-user-role.component';
interface UploadedFileList {
  id: string | null;
  files: File[];
}

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
})
export class CreateUserComponent implements OnInit, OnDestroy {
  @ViewChild('uploadFileInput') uploadFileInput: ElementRef | undefined;
  @ViewChildren('userFileInput') userFileInputs!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup | undefined;
  @Input() school: DtoSchool = {} as DtoSchool;
  @Input() clientAccountId: number = 0;
  @Input() isEdit: boolean = false;
  @Input() schoolData: DtoSchool[] = [];
  @Input() assignedPackageId: number = 0;
  @Input() standaloneMenu: boolean = false;
  @Input() schoolId: (number | null)[] = [];

  selectedFile: File | null = null;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  schoolNames: string[] = [];
  schoolDetailsForm = this.fb.group({
    schools: this.fb.array([])
  });
  showSchoolUserDetailsList: boolean = false;
  schoolUserData: DtoSchoolUser[] = [];
  selectedIndex: number = 0;
  roles: Role[] = [];
  excelData: DtoSchoolUser[] = [];
  rolesMaster = RoleMaster;
  roleName: string[] = [];
  userEmail: string = "";
  userRole: string[] = [];
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  schoolUsersUploadedFileList: { [index: number]: UploadedFileList[] } = {};
  subscription: Subscription = new Subscription();
  selectedFileCount: number[] = [];
  isBulkUploadActive: boolean = false;

  constructor(public dialog: MatDialog, private fb: FormBuilder,
              private sharedService: SharedService, private helperMethods: HelperMethods,
              private toasterService: ToastrService, private schoolService: SchoolService
  ) {} 

  ngOnInit(): void {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });
    this.sharedService.schoolFormValidity.subscribe(schoolForm => {
      if(schoolForm.controls['schools']){
        this.schoolDetailsForm = schoolForm;
        if(!this.isBulkUploadActive){
          this.initializeSchoolUsers();
        }
      }
    });
    this.schoolDetailsForm.statusChanges.subscribe(status => {
      this.sharedService.updateSchoolFormValidity(this.schoolDetailsForm);
    });
    setTimeout(() => {
      this.sharedService.updateSchoolFormValidity(this.schoolDetailsForm);
      if(this.tabGroup){
        this.tabGroup.selectedIndex = 0;
        this.selectedIndex = 0;
        const school = this.schoolDetailsForm.controls['schools'].at(this.selectedIndex) as unknown as FormGroup;
        const schoolUsers = school.get('schoolUsers')?.value;
        if(schoolUsers.length > 1){
          this.schoolUserData = schoolUsers;
          this.showSchoolUserDetailsList = true;
        }
        else{
          this.showSchoolUserDetailsList = false;
        }
      }
    });
    this.getRoles(this.clientAccountId);
    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      if(data){
        this.uploadFromLocal(data, this.selectedIndex, true);
      }
    }));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  bulkUpload(){
    if (this.uploadFileInput) {
      this.uploadFileInput.nativeElement.click();
    }
  }

  downloadFile(): void {
    const blobName = 'TemplateForBulkUploadSchoolUser.xlsx'; // Specify the file name you want to download
    this.schoolService.downloadFile(blobName).subscribe((response: any) => {

      var url = response.blobUrl.toString();
      for (var i = 0; i < url.length; i++) {
        url = url.replace("~", "");
        url = url.replace("//", "%2F%2F");
        url = url.replace("/", "%2F");
        url = url.replace(":", "%3A");
    }
    console.log(url);
     var ViewDocumentUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
     window.open(ViewDocumentUrl, "_blank");
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  async loadExcelData(event: any) {
    this.isBulkUploadActive = false;
    this.isBulkUploadActive = true;
    await this.removeInvalidUsers(this.selectedIndex);
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = (e) => {
      var workBook = XLSX.read(fileReader.result, {type: 'binary'});
      var sheetNames = workBook.SheetNames;
      this.excelData = XLSX.utils.sheet_to_json(workBook.Sheets[sheetNames[0]]);
      if (this.excelData.length === 0) {
        this.toasterService.warning('Uploaded excel file (Sheet No: 1) is empty or does not contain valid data');
        this.initializeSchoolUsers();
        return;
      }
      const lowerCase = (str: string | any[]) => str[0].toLowerCase() + str. slice(1);
      const res = this.excelData.map(
        obj => Object.fromEntries(Object.entries(obj).map(
          ([k, v]) => [lowerCase(k), v])
        )
      );
      this.excelData = res;
      console.log((this.excelData));
      
      let emailIds = this.excelData.filter(x => x.emailId !== undefined && x.emailId !== '').map(x=>{return x.emailId});
      if(emailIds.length == 0){
        this.toasterService.warning("Uploaded excel is incorrect. Please try again with a valid excel");
        this.initializeSchoolUsers();
        return;
      }

      let school: DtoSchool = this.schoolDetailsForm.controls['schools'].at(this.selectedIndex).value as DtoSchool;
      this.toasterService.info("Uploaded " + res.length + " user details for " + school.schoolName);      

      for (let index = 0; index < this.excelData.length; index++) {
        const element = this.excelData[index];
        if(index == 0){
          school.schoolUsers = [];
        }
        school.schoolUsers.push(element);
        this.showSchoolUserDetailsList = school.schoolUsers.length>1 ? true : false
      }
      setTimeout(()=>{
        this.addSchoolUser(this.selectedIndex, school);
        //this.isBulkUploadActive = false;
      }, 2000)
      event.target.value = null;
    }
  }

  async removeInvalidUsers(schoolIndex: number): Promise<void> {
    const schoolGroup = this.schools.at(schoolIndex) as FormGroup;
    const schoolUsersArray = schoolGroup.get('schoolUsers') as FormArray;

    for (let i = schoolUsersArray.length - 1; i >= 0; i--) {
      const schoolUserGroup = schoolUsersArray.at(i) as FormGroup;
      if (schoolUserGroup.invalid) {
        await this.removeSchoolUser(schoolIndex, i);
      }
    }
  }

  getRoles(clientAccountId: number){
    let schoolId;
    if(!clientAccountId) {
      schoolId = this.schoolId && this.schoolId.length > 0 ? this.schoolId : [this.schoolId]
    }
    let payload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [clientAccountId] : schoolId
    } as RolePayload;
    this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
      this.roles = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  filterRolesForIndependentSchools(){
    if(this.clientAccountId > 0){
      return this.roles.filter(x=>x.isActive == true);
    }
    let school = this.schoolData[this.selectedIndex];
    return this.roles.filter(x=>x.individualSchoolId == school.schoolId && x.isActive == true);
  }

  createRole(){
    this.dialog.open(EditUserRoleComponent, {
      width: '1000px',
      data:{
        role: {},
        packageId: this.assignedPackageId,
        clientAccountId: this.clientAccountId,
        schoolId: this.schoolId
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getRoles(this.clientAccountId);
        setTimeout(()=>{
          this.filterRolesForIndependentSchools();
        }, 1000);
      }
    });
  }

  initializeSchoolUsers(): void {
    const schools = this.schoolDetailsForm.get('schools') as FormArray;
    schools.controls.forEach((school, index) => {
      this.addInitialUsers(school, index);
    }); 
  }

  addInitialUsers(school: FormGroup | any, index: number): void {
    const users = school.get('schoolUsers') as FormArray;
    if (users.length === 0) {
      if(this.isEdit){
        this.showSchoolUserDetailsList = true;
        this.addSchoolUser(index, this.schoolData[index])
      }
      else{
        this.addSchoolUser(index);
      }
    }
  }

  openConfirmDialog(event: Event): void {
    event.preventDefault();
    this.dialog.open(ConfirmDialogComponent, { width: '675px' });
  }

  getFilesForSchooluser(index: number): File[] {
    const schoolUploadFileList = this.schoolUsersUploadedFileList[index]?.[0];
    return schoolUploadFileList ? schoolUploadFileList.files || [] : [];
  }

  uploadFromLocal(event: Event, index: number, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.getFilesForSchooluser(index));
      this.dialog.open(ConfirmDialogComponent, { width: '675px', data: {
        hideUpload: false,
        isParentUpload: true
      }}).afterClosed().subscribe(() => {
        this.selectedFileCount[index] = this.getFilesForSchooluser(index).length;
      });
    }

    const fileInput = this.userFileInputs.toArray()[index];
    if (fileInput  && index === this.selectedIndex) {
      fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: any, index: number) {
    if (!this.schoolUsersUploadedFileList[index]) {
      this.schoolUsersUploadedFileList[index] = [{ id: null, files: [] }]
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if(event.target.files[i].size <= this.maxSize){
            let _object: File = event.target.files[i];

            this.schoolUsersUploadedFileList[index][0].files.push(_object);
            const schoolFormGroup = this.schools.at(index) as FormGroup;
            const schoolUsers = schoolFormGroup.get('schoolUsers') as FormArray;

            const uploadedFileList = schoolUsers.at(0).get('UploadedFileList') as FormArray;

            // Clear the existing files
            uploadedFileList.clear();

            this.schoolUsersUploadedFileList[index][0].files.forEach(file => {
              uploadedFileList.push(this.fb.control(file));
            });
          }
          else{
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.schoolUsersUploadedFileList[index][0].files);
      this.selectedFileCount[index] = this.schoolUsersUploadedFileList[index][0].files.length;

      // Clear the file input value
      if (this.userFileInputs.toArray()[index]) {
        this.userFileInputs.toArray()[index].nativeElement.value = "";
      }
    }
  }

  addSchoolUser(schoolIndex: number, schoolList: DtoSchool = {} as DtoSchool) {
    const school = this.schoolDetailsForm.controls['schools'].at(schoolIndex) as unknown as FormGroup;
    if(schoolList.location){
        const schoolUsers = school.get('schoolUsers') as FormArray;
        schoolList.schoolUsers.forEach((schoolUser: DtoSchoolUser) => {
          if(schoolUser.firstName){
            let newForm = this.getSchoolUserForm();

            let examplePhoneNumber = `+${schoolUser.countryCode?.toString()!}${schoolUser.phoneNumber?.toString()!}`;
            let formattedNumber = this.phoneNumberUtil.format(
              this.phoneNumberUtil.parse(examplePhoneNumber),
              PhoneNumberFormat.INTERNATIONAL
            );
            newForm.patchValue({
                schoolUserId: schoolUser.schoolUserId,
                schoolId: schoolUser.schoolId,
                title: schoolUser.title,
                firstName: schoolUser.firstName,
                lastName: schoolUser.lastName,
                emailId: schoolUser.emailId,
                contactNumber: formattedNumber,
                role: schoolUser.role
            });           
            // Handle nullable uploadedFiles
            if (schoolUser.useruploadedFiles && schoolUser.useruploadedFiles.length > 0) {
              const uploadedFileList = newForm.get('UploadedFileList') as FormArray;
              schoolUser.useruploadedFiles.forEach(file => {
                uploadedFileList.push(this.fb.control(file));
              });
            }
            schoolUsers.push(newForm);
          }
        });
        this.schoolUserData = schoolUsers.value;
    }
    else{
      const schoolUsers = school.get('schoolUsers') as FormArray;
      schoolUsers.push(this.getSchoolUserForm());
    }
  }

  getSchoolUserForm(){
    const schoolForm = this.fb.group ({
      schoolUserId: [null as number | null],
      schoolId: [null as number | null],
      title: ['', [Validators.required]],
      firstName: ['', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]],
      lastName: ['', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]],
      emailId: ['', [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"),
      ]],
      contactNumber: ['', [
        this.helperMethods.PhoneNumberValidator(),
      ]],
      role: [[] as Role[],Validators.required],
      UploadedFileList: this.fb.array([])
    });
    return schoolForm;
  }

  clearSchoolUserForm(){
    this.schoolUsersUploadedFileList = [];
    this.selectedFileCount = [];
    let arrayLength = this.schools.length;
    for (let i = 0; i< arrayLength; i++) {
      let school = this.schools.at(i) as FormGroup;
      let users = school.get('schoolUsers') as FormArray;
      for (let j = 0; j < users.length; j++) {
        users.removeAt(j);
        if(users.length == 0) {
          this.addSchoolUser(i);
        }
      }
    }
  }
  
  onSchoolChange(index: number) {
    this.selectedIndex = index;

    const school = this.schoolDetailsForm.controls['schools'].at(index) as unknown as FormGroup;
    const schoolUsers = school.get('schoolUsers')?.value;
    if(schoolUsers.length > 1){
      this.schoolUserData = schoolUsers;
      this.showSchoolUserDetailsList = true;
    }
    else{
      this.showSchoolUserDetailsList = false;
    }
  }
  
  openAddSchoolUserPopup(schoolIndex: number){
    const school = this.schoolDetailsForm.controls['schools'].at(schoolIndex) as unknown as FormGroup;
    const schoolUsers = school.get('schoolUsers')?.value;
    if(school.value.numberOfSchoolUser-1 <= schoolUsers.length){
      this.toasterService.error("Maximum number of school users for this school has already been created");
      return;
    }
    if(!this.showSchoolUserDetailsList){
      this.schoolUserData = schoolUsers;
      this.showSchoolUserDetailsList = true;
    }
    else{
      this.openCreateSchoolUserDialog(schoolIndex, "add");
    }
  }

  openCreateSchoolUserDialog(schoolIndex: number, action: string, userDetail: DtoSchoolUser = {} as DtoSchoolUser){
    //Opened upon Create User screen (After create school)
    const school = this.schoolDetailsForm.controls['schools'].at(schoolIndex) as unknown as FormGroup;
    const schoolUsers = school.get('schoolUsers')?.value;
    if(school.value.numberOfSchoolUser-1 <= schoolUsers.length && action != "edit" ){
      this.toasterService.error("Maximum number of school users for this school has already been created");
      return;
    }
    this.dialog.open(AddSchoolUserComponent, {
      width: '1000px',
      data: {
        userDetail: userDetail,
        roles: this.filterRolesForIndependentSchools(),
        assignedPackageId: this.assignedPackageId,
        clientAccountId: this.clientAccountId,
        allowBulkUpload: false
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        popupEvent.data.userDetails.countryCode = this.phoneNumberUtil.parse(popupEvent.data.userDetails.contactNumber?.toString()).getCountryCode()!;
        popupEvent.data.userDetails.phoneNumber = this.phoneNumberUtil.parse(popupEvent.data.userDetails.contactNumber?.toString()).getNationalNumber()!;

        const school = this.schoolDetailsForm.controls['schools'].at(schoolIndex) as unknown as FormGroup;
        const schoolUserArray = school.get('schoolUsers') as FormArray;
        let schoolUsers = school.get('schoolUsers')?.value;
        let userIndex = schoolUsers.findIndex((user: DtoSchoolUser) => user.emailId === userDetail.emailId);
        
        if (action == "edit" && schoolUserArray && schoolUserArray.length > userIndex) {
          this.removeSchoolUser(this.selectedIndex, userIndex);
          let schoolSample = {...this.schoolDetailsForm.controls['schools'].at(schoolIndex).value!} as DtoSchool;
          schoolSample.schoolUsers = [];
          schoolSample.schoolUsers.push(popupEvent.data.userDetails);
          this.toasterService.success('User details updated successfully', 'Success');
          this.addSchoolUser(this.selectedIndex, schoolSample);
        }
        else {
          let schoolSample = {...this.schoolDetailsForm.controls['schools'].at(schoolIndex).value!} as DtoSchool;
          schoolSample.schoolUsers = [];
          if (popupEvent.data.fileData) {
            // Create an array of files from FormData
            let uploadedFiles: File[] = [];
            popupEvent.data.fileData.forEach((value: File) => {
              uploadedFiles.push(value);
            });
        
            // Map the files to the uploadedFiles property in userDetails
            popupEvent.data.userDetails.useruploadedFiles = uploadedFiles;
          }
          schoolSample.schoolUsers.push(popupEvent.data.userDetails);
          this.toasterService.success('User details created successfully!', 'Success');
          this.addSchoolUser(this.selectedIndex, schoolSample);
        }
      }
      this.getRoles(this.clientAccountId);
      this.showSchoolUserDetailsList = this.schoolUserData.length > 1 ? true : false;
    });
  }

  async removeSchoolUser(schoolIndex: number, userIndex: number): Promise<void> {
    const school = this.schools.at(schoolIndex) as FormGroup;
    const users = school.get('schoolUsers') as FormArray;
    users.removeAt(userIndex);
    const schoolUsers = school.get('schoolUsers')?.value;
    this.schoolUserData = schoolUsers;
    this.showSchoolUserDetailsList = this.schoolUserData.length > 1 ? true : false;
  }

  get schools(): FormArray {
    return this.schoolDetailsForm.get('schools') as FormArray;
  }

  actionTriggered(value: any) {
    let action = value.action;
    let index = value.index;
    let roleData: Role[] = value.role;
    let school = this.schoolDetailsForm.controls['schools'].at(this.selectedIndex) as unknown as FormGroup;
    switch(action){
      case ActionType.CreateAnotherUser:
        this.openCreateSchoolUserDialog(this.selectedIndex, "add");
        return;
      case ActionType.BulkUpload:
        return;
      case ActionType.UpdateRole:
        let schoolUser = school.controls['schoolUsers'] as FormArray;
        let roleList = this.roles.filter((role: Role) => {
          return roleData.some((userRole: Role) => role.roleId === userRole.roleId);
        });
        schoolUser.controls[index].get('role')?.setValue(roleList);
        return;
      case ActionType.EditSchoolUser:
        this.openCreateSchoolUserDialog(this.selectedIndex, "edit", school.controls['schoolUsers'].value.at(index));
        return;
      case ActionType.DeleteSchoolUser:
        this.openDeleteSchoolUser(this.selectedIndex, index);
        return;
      default:
        return ""
    }
  }

  openDeleteSchoolUser(schoolIndex: number, userIndex: number){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to  delete the School User?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.removeSchoolUser(schoolIndex, userIndex);
      }
    });
  }
}

export enum ActionType { CreateAnotherUser = "create", BulkUpload = "bulkUpload", EditSchoolUser = "edit", DeleteSchoolUser = "delete", UpdateRole = "updateRole" }